import {
  CORPORATE_COMPANY,
  CORPORATE_TIMELINE,
  CORPORATE_VALUES,
} from "../CorporatePortalContent";

export default function CorporateAboutPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">关于我们</h1>
          <p className="corporate-page-banner-desc">
            聚焦 AI 与组织管理、知识分享、影视创作，用陪伴式落地帮助团队真正用好 AI。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <h2 className="corporate-section-title">公司简介</h2>
          <p className="corporate-section-desc">{CORPORATE_COMPANY.intro}</p>
          <div className="corporate-card-grid">
            <div className="corporate-card">
              <h3 className="corporate-card-title">使命</h3>
              <p className="corporate-card-text">
                让 AI 成为每一家组织的新生产力——不是实验室概念，而是日常工作中真正在用的工具与方法论。
              </p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">愿景</h3>
              <p className="corporate-card-text">
                成为 AI 时代组织赋能与知识传播的平台型服务商，在组织管理、知识分享、内容创作三大领域形成标准化交付能力。
              </p>
            </div>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">我们的理念</h2>
          <div className="corporate-card-grid corporate-card-grid-3">
            {CORPORATE_VALUES.map((item) => (
              <div key={item.title} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">发展历程</h2>
          <div className="corporate-timeline">
            {CORPORATE_TIMELINE.map((item, index) => (
              <div key={`${item.year}-${index}`} className="corporate-timeline-item">
                <div className="corporate-timeline-year">{item.year}</div>
                <p className="corporate-card-text">{item.event}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">团队与资质</h2>
          <div className="corporate-card-grid">
            <div className="corporate-card">
              <h3 className="corporate-card-title">核心团队</h3>
              <p className="corporate-card-text">
                成员具备 AI 工程、组织管理与内容创作复合背景，兼具理论宣讲、实践陪跑与系统开发能力，坚持能演示的不说、面向结果的交付标准。
              </p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">技术基座</h3>
              <p className="corporate-card-text">
                基于 MagicVector 基座快速搭建客户系统，麻雀项目管理系统持续迭代，为大V 数字人平台与 AI 影视制作提供底层支撑。
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
